// Feature: Backend. Requests, logs, and metrics from connected services,
// linked to the replays that caused them. Registers routes and nav; see
// features/registry.ts.
import { createRoute } from "@tanstack/react-router";
import { registerFeature } from "../registry";
import { ConnectPage } from "./pages/ConnectPage";
import { LogsPage } from "./pages/LogsPage";
import { MapPage } from "./pages/MapPage";
import { MetricsPage } from "./pages/MetricsPage";
import { ServiceDetailPage, ServicesPage } from "./pages/ServicesPage";
import { SettingsPage } from "./pages/SettingsPage";
import { TraceDetailPage } from "./pages/TraceDetailPage";
import { TracesPage } from "./pages/TracesPage";
import "./backend.css";

const passSearch = (s: Record<string, unknown>) => s;

registerFeature({
  routes: (appRoute) => [
    createRoute({ getParentRoute: () => appRoute, path: "/backend", component: TracesPage, validateSearch: passSearch }),
    createRoute({ getParentRoute: () => appRoute, path: "/backend/traces/$traceId", component: TraceDetailPage, validateSearch: passSearch }),
    createRoute({ getParentRoute: () => appRoute, path: "/backend/logs", component: LogsPage, validateSearch: passSearch }),
    createRoute({ getParentRoute: () => appRoute, path: "/backend/metrics", component: MetricsPage, validateSearch: passSearch }),
    createRoute({ getParentRoute: () => appRoute, path: "/backend/services", component: ServicesPage, validateSearch: passSearch }),
    createRoute({ getParentRoute: () => appRoute, path: "/backend/services/$service", component: ServiceDetailPage, validateSearch: passSearch }),
    createRoute({ getParentRoute: () => appRoute, path: "/backend/map", component: MapPage, validateSearch: passSearch }),
    createRoute({ getParentRoute: () => appRoute, path: "/backend/connect", component: ConnectPage }),
    createRoute({ getParentRoute: () => appRoute, path: "/backend/settings", component: SettingsPage }),
  ],
  nav: [{ label: "Backend", to: "/backend", section: "main", order: 5 }],
});
